<template>
  <div class="order_wrap elTab">
    <div class="order">
      <el-row class="tab_header">
        <el-col :span="24">
          <el-tabs v-model="active" @tab-click="handleClick">
            <el-tab-pane label="订单列表" :name="route.order"></el-tab-pane>
            <el-tab-pane
              label="送样单列表"
              :name="route.sampleList"
            ></el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>

      <div class="operation">
        <div class="btn">
          <el-button type="primary" size="medium" @click="handleCreate">
            新建送样单
          </el-button>
        </div>
        <div class="queryForm">
          <el-form :inline="true" class="demo-form-inline" :model="form">
            <el-form-item>
              <el-input
                v-model="form.contractNo"
                placeholder="合同号"
                size="medium"
                clearable
                class="input-style"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.orderNo"
                placeholder="订单号"
                size="medium"
                clearable
                class="input-style"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="handleSearch"
                >搜索</el-button
              >
              <el-button
                @click="handleReset"
                size="medium"
                style="margin-left: 10px"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="tableForm">
        <el-table
          :data="tableData"
          :header-cell-style="{
            'background-color': '#fafafa',
            color: '#000000',
            'font-weight': 400,
          }"
          stripe
          class="elTable"
        >
          <el-table-column
            prop="orderNo"
            label="订单号"
            min-width="20%"
          ></el-table-column>
          <el-table-column
            prop="contractNo"
            label="合同号"
            min-width="20%"
          ></el-table-column>
          <el-table-column
            prop="lcb"
            label="里程碑"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="trackingNumber"
            label="快递单号"
            min-width="15%"
          ></el-table-column>
          <el-table-column
            prop="fileName"
            label="送样单文件名称"
            min-width="15%"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="10%">
            <template slot-scope="scope">
              <span>{{ $utils.map.parseTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" min-width="20%">
            <template slot-scope="scope">
              <span class="item" @click="handleUpdate(scope.row)">
                <span class="title">编辑</span>
              </span>
              <span class="item" @click="downloadFile(scope.row)">
                <span class="title">下载送样单</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="elPagination" v-if="total > 0">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="pageSizes"
        :page-size="form.pageSize"
        :total="total"
      >
      </el-pagination>
    </div>

    <save-sample-list v-model="showCreate" :row-data="currentRow" @refresh="getSampleList" />
  </div>
</template>


<script>
import { getSampleList } from "@/api/sampleList/sampleList";
import SaveSampleList from "./SaveSampleList.vue";

export default {
  name: "sampleList",

  components: {
    SaveSampleList,
  },

  data() {
    return {
      active: "/bsg/ltc/sampleList", // 当前激活的tab = 自己的路由
      route: {
        order: "/bsg/ltc/order",
        sampleList: "/bsg/ltc/sampleList",
      },
      form: {
        contractNo: "", // 合同号
        orderNo: "", // 订单号
        pageNum: 1,
        pageSize: 12,
      },
      pageSizes: [12, 24, 36],
      tableData: [],
      total: 0,
      showCreate: false, //展示新建送样单
      currentRow: null,
    };
  },

  created() {
    this.getSampleList();
  },

  methods: {
    handleCreate() {
      this.currentRow = null;
      this.showCreate = true;
    },

    handleUpdate(row) {
      this.currentRow = row;
      this.showCreate = true;
    },

    handleClick() {
      this.$router.push(this.active);
    },

    // 搜索
    handleSearch() {
      this.form.pageNum = 1;
      this.getSampleList();
    },

    // 重置
    handleReset() {
      this.form.contractNo = "";
      this.form.orderNo = "";
      this.form.pageNum = 1;
      this.getSampleList();
    },

    // 改变页数
    handleCurrentChange(val) {
      this.form.pageNum = val;
      this.getSampleList();
    },

    // 改变每页数量
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getSampleList();
    },
    getSampleList() {
      const params = {
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize,
        contractNo: this.form.contractNo, //合同号
        orderNo: this.form.orderNo, //订单号
      };

      getSampleList(params).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },

    downloadFile(row) {
      window.open(row.fileUrl);
    },


  },
};
</script>

<style lang="scss" scoped>
@import "@/views/components/order/order/order/index.scss";

/* 让"新建送样单"按钮与右侧搜索表单在一条水平线上垂直居中 */
.operation {
  align-items: center;
  flex-wrap: nowrap;
  height: 51px;
  box-sizing: border-box;

  .el-button {
    height: 36px;
    line-height: 36px;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.btn {
  display: flex;
  align-items: center;
}

/* 与订单页 queryForm 组件保持一致的横向排列与高度 */
.queryForm {
  .demo-form-inline {
    @include start;
    display: flex;
    flex-direction: row;

    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        display: flex;
        align-items: center;
        line-height: 36px;
      }

      .el-input {
        display: inline-flex;
      }
    }
  }

  .input-style {
    width: 200px;
  }
}

/* 与 bsgTable 的 el-table 保持一致：允许单元格内容溢出 */
.elTable ::v-deep .cell {
  overflow: visible;
}

.item {
  cursor: pointer;
  margin-right: 10px;
}
.elTable ::v-deep .item .title {
  color: $theme_color;
}
</style>
